import ApiService from '@/common/api/api.service';
import helpers from '@/common/utils/helpers';

let apiBasePath = 'Funcionario';

const FuncionarioService = {
  async buscarPorId(id) {
    const { data: funcionario } = await ApiService.get(`${apiBasePath}/${id}`);
    const response = {
      ...funcionario.data,
      tipoFuncionario: {
        text: funcionario.data?.tipoFuncionarioDescricao ?? '',
        value: funcionario.data?.tipoFuncionarioId ?? '',
      },
      cargo: {
        text: funcionario.data?.cargoDescricao,
        value: funcionario.data?.cargoId,
      },
      departamento: {
        text: funcionario.data?.departamentoDescricao,
        value: funcionario.data?.departamentoId,
      },
      banco: {
        value: funcionario.data?.banco?.id,
        text: funcionario.data?.banco?.descricao,
      },
      grauInstrucao: {
        value: funcionario.data?.grauInstrucaoId,
        text: funcionario.data?.grauInstrucaoDescricao,
      },
    };

    return response;
  },

  async listarFuncionarioPorTipo(paginacao, filtro, campoOrdenado, ordem) {
    const { nome, status, tipoFuncionario } = filtro;
    const parametros = {
      TamanhoDaPagina: paginacao.tamanhoDaPagina,
      NumeroDaPagina: paginacao.numeroDaPagina,
      ...(nome && { Nome: nome }),
      ...(status && { Status: status }),
      ...(tipoFuncionario && { tipoFuncionario: tipoFuncionario }),
      CampoOrdenado: campoOrdenado,
      OrdenacaoAscendente: ordem,
    };

    const { data } = await ApiService.get(
      `${apiBasePath}/${parametros.tipoFuncionario}`,
      { params: { ...parametros } }
    );

    return data;
  },

  async criar(dados) {
    const dadosFormatados = {
      pessoaId: dados.pessoaId?.value,
      carteiraProfissional: helpers.removerMascara(dados.carteiraProfissional),
      tituloEleitor: dados.tituloEleitor,
      secao: dados.secao,
      registroProfissional: dados.registroProfissional,
      conta: helpers.removerMascara(dados.conta),
      agencia: dados.agencia,
      titulacoes: dados.titulacoes,
      pis: dados.pis,
      dataAdmissao: dados.dataAdmissao,
      diplomas: dados.diplomas,
      tipoFuncionario: dados.tipoFuncionario?.descricao,
      grauInstrucao: dados.grauInstrucao?.value
        ? dados.grauInstrucao.value
        : dados.grauInstrucao,
      cargo: dados.cargo?.value ? dados.cargo.value : dados.cargo,
      departamento: dados.departamento?.value ? dados.departamento.value : dados.departamento,
      bancoId: dados.banco?.id,
    };
    const { data } = await ApiService.post(`${apiBasePath}`, dadosFormatados);
    return data;
  },

  async atualizar(dados) {
    const dadosFormatados = {
      ...dados,
      pessoaId: dados.pessoaId,
      bancoId: dados.banco?.value,
      cargo: dados.cargo?.value,
      departamento: dados.departamento?.value,
      tipoFuncionario: dados.tipoFuncionario?.value,
      grauInstrucao: dados.grauInstrucao?.value,
      conta: helpers.removerMascara(dados.conta),
      carteiraProfissional: helpers.removerMascara(dados.carteiraProfissional),
    };
    const { data } = await ApiService.put(`${apiBasePath}`, dadosFormatados);
    return data;
  },

  async excluir(id) {
    const { data } = await ApiService.delete(`${apiBasePath}/${id}`);
    return data;
  },

  async editar(id) {
    const { data } = await ApiService.get(`${apiBasePath}/${id}`);
    return data;
  },

  async imprimirRelatorioFuncionarios(params) {
    let { data } = await ApiService.get(
      `${apiBasePath}/imprimir-relatorio-funcionarios`,
      {
        params: {
          tipoFuncionario: params.tipoFuncionario,
          status: params.status,
          cargo: params.cargo,
          departamento: params.departamento,
          exibirNome: params.exibirNome,
          exibirCPF: params.exibirCPF,
          exibirDataNascimento: params.exibirDataNascimento,
          exibirCargo: params.exibirCargo,
          exibirDataAdmissao: params.exibirDataAdmissao,
          exibirDataDemissao: params.exibirDataDemissao,
          exibirTelefone: params.exibirTelefone,
          exibirEmail: params.exibirEmail,
          exibirEndereco: params.exibirEndereco,
          exibirDepartamento: params.exibirDepartamento,
        },
      }
    );
    return data;
  },
};

export default FuncionarioService;
